import { useAuth } from "@/shared/auth/useAuth";
import { Button } from "@/shared/components/ui/button";
import { AssistantLauncher } from "@/features/assistant/AssistantLauncher";

/**
 * Slim top bar: active-tenant switcher (left), signed-in identity + sign-out
 * (right). The tenant switcher only shows a picker when the user can reach more
 * than one tenant; a single-tenant user just sees the tenant name.
 */
export function Topbar() {
  const { user, switchTenant, signOut } = useAuth();
  if (!user) return null;

  const active = user.tenants.find((t) => t.id === user.activeTenantId) ?? user.tenants[0];

  return (
    <header className="flex h-14 flex-shrink-0 items-center justify-between border-b border-ge-border-subtle bg-ge-sidebar/60 px-6">
      <div className="flex items-center gap-2">
        <span className="ge-eyebrow">TENANT</span>
        {user.tenants.length > 1 ? (
          <select
            data-testid="tenant-switcher"
            aria-label="Active tenant"
            value={active?.id ?? ""}
            onChange={(e) => void switchTenant(e.target.value)}
            className="rounded-ge-param border border-ge-border-card bg-ge-card px-2 py-1 font-mono text-[12px] text-ge-value focus-visible:outline-none"
          >
            {user.tenants.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}
              </option>
            ))}
          </select>
        ) : (
          <span className="font-mono text-[12px] text-ge-value" data-testid="tenant-name">
            {active?.name ?? "—"}
          </span>
        )}
      </div>

      <div className="flex items-center gap-4">
        <AssistantLauncher />
        <span className="hidden font-mono text-[11px] text-ge-secondary sm:inline" data-testid="user-email">
          {user.email}
        </span>
        <Button variant="ghost" size="sm" data-testid="sign-out-button" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
